import { SelectHTMLAttributes, forwardRef } from 'react';

interface Option {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: Option[];
  placeholder?: string;
  error?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, options, placeholder, error, className = '', ...rest },
  ref
) {
  return (
    <label className="block w-full">
      {label && <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>}
      <select
        ref={ref}
        className={[
          'h-[50px] w-full appearance-none rounded-xl border bg-surface px-4 pr-9 text-[15px] text-ink-800',
          'transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400',
          'bg-[url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%238b938e" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>\')] bg-no-repeat bg-[right_0.9rem_center]',
          error ? 'border-critical' : 'border-ink-200',
          className,
        ].join(' ')}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className="mt-1 block text-xs text-critical">{error}</span>}
    </label>
  );
});
